const entries = [
  ["Показать ссылку клиента", "Show customer link", "Müşteri bağlantısını göster"],
  ["Загрузка ссылки…", "Loading link…", "Bağlantı yükleniyor…"],
  ["Ссылка на страницу клиента", "Customer page link", "Müşteri sayfası bağlantısı"],
  ["Открыть страницу клиента", "Open customer page", "Müşteri sayfasını aç"],
  ["Копировать ссылку клиента", "Copy customer link", "Müşteri bağlantısını kopyala"],
  ["Ссылка клиента скопирована.", "Customer link copied.", "Müşteri bağlantısı kopyalandı."],
  ["Не удалось скопировать. Выделите ссылку вручную.", "Could not copy. Select the link manually.", "Kopyalanamadı. Bağlantıyı elle seçin."],
  ["Ссылка клиента недоступна или срок её действия истёк.", "The customer link is unavailable or has expired.", "Müşteri bağlantısı kullanılamıyor veya süresi dolmuş."],
  ["Отправить выбранные фотографии", "Send selected photos", "Seçilen fotoğrafları gönder"],
  [
    "Заказы магазина",
    "Store orders",
    "Mağaza siparişleri"
  ],
  [
    "Оплаченные заказы, сборка и доставка Terbium Gifts.",
    "Paid orders, assembly and delivery for Terbium Gifts.",
    "Terbium Gifts ödenmiş siparişleri, hazırlama ve teslimat."
  ],
  [
    "Номер, Email или телефон заказчика",
    "Order number, buyer email or phone",
    "Sipariş numarası, alıcı e-postası veya telefonu"
  ],
  [
    "Введите точное значение целиком.",
    "Enter the complete, exact value.",
    "Tam ve birebir değeri girin."
  ],
  [
    "Статус заказа",
    "Order status",
    "Sipariş durumu"
  ],
  [
    "Все статусы",
    "All statuses",
    "Tüm durumlar"
  ],
  [
    "Оплачен с (UTC)",
    "Paid from (UTC)",
    "Ödeme başlangıcı (UTC)"
  ],
  [
    "Оплачен по (UTC), включительно",
    "Paid through (UTC), inclusive",
    "Ödeme bitişi (UTC), dahil"
  ],
  [
    "Применить фильтры",
    "Apply filters",
    "Filtreleri uygula"
  ],
  [
    "Загрузка заказов…",
    "Loading orders…",
    "Siparişler yükleniyor…"
  ],
  [
    "Найдено заказов",
    "Orders found",
    "Bulunan siparişler"
  ],
  [
    "Время оплаты указано в UTC.",
    "Payment times are shown in UTC.",
    "Ödeme saatleri UTC olarak gösterilir."
  ],
  [
    "Оплаченные заказы не найдены",
    "No paid orders found",
    "Ödenmiş sipariş bulunamadı"
  ],
  [
    "Проверьте фильтры. Неоплаченные инвойсы сюда не попадают.",
    "Check the filters. Unpaid invoices do not appear here.",
    "Filtreleri kontrol edin. Ödenmemiş faturalar burada görünmez."
  ],
  [
    "Список заказов магазина",
    "Store order list",
    "Mağaza sipariş listesi"
  ],
  [
    "Открыть заказ",
    "Open order",
    "Siparişi aç"
  ],
  [
    "Заказы магазина доступны администратору и менеджеру магазина.",
    "Store orders are available to administrators and store managers.",
    "Mağaza siparişlerine yöneticiler ve mağaza yöneticileri erişebilir."
  ],
  [
    "К списку заказов",
    "Back to orders",
    "Siparişlere dön"
  ],
  [
    "Обновить заказ",
    "Refresh order",
    "Siparişi yenile"
  ],
  [
    "Загрузка заказа…",
    "Loading order…",
    "Sipariş yükleniyor…"
  ],
  [
    "Заказ",
    "Order",
    "Sipariş"
  ],
  [
    "Оплачен",
    "Paid",
    "Ödendi"
  ],
  [
    "Язык заказа",
    "Order language",
    "Sipariş dili"
  ],
  [
    "Выполнение заказа",
    "Fulfillment",
    "Siparişin hazırlanması"
  ],
  [
    "До автоматического подтверждения",
    "Until automatic approval",
    "Otomatik onaya kalan süre"
  ],
  [
    "Срок ответа",
    "Response deadline",
    "Yanıt süresi"
  ],
  [
    "Причина от покупателя",
    "Customer’s reason",
    "Müşterinin gerekçesi"
  ],
  [
    "Карточка проверяет изменения каждые 10 секунд, пока открыта и нет незавершённого действия.",
    "The open order checks for changes every 10 seconds while no action is pending.",
    "Açık sipariş, bekleyen işlem yokken her 10 saniyede değişiklikleri kontrol eder."
  ],
  [
    "Заказчик",
    "Buyer",
    "Siparişi veren"
  ],
  [
    "Имя и фамилия",
    "First and last name",
    "Ad ve soyad"
  ],
  [
    "Телефон заказчика",
    "Buyer phone",
    "Sipariş verenin telefonu"
  ],
  [
    "Гостевой заказ",
    "Guest order",
    "Misafir siparişi"
  ],
  [
    "Аккаунт Terbium",
    "Terbium account",
    "Terbium hesabı"
  ],
  [
    "Получатель и доставка",
    "Recipient and delivery",
    "Alıcı ve teslimat"
  ],
  [
    "Получатель",
    "Recipient",
    "Alıcı"
  ],
  [
    "Телефон получателя",
    "Recipient phone",
    "Alıcının telefonu"
  ],
  [
    "Регион доставки",
    "Delivery region",
    "Teslimat bölgesi"
  ],
  [
    "Адрес доставки",
    "Delivery address",
    "Teslimat adresi"
  ],
  [
    "Когда доставить",
    "Delivery schedule",
    "Teslimat zamanı"
  ],
  [
    "Как можно скорее",
    "As soon as possible",
    "Mümkün olan en kısa sürede"
  ],
  [
    "Время доставки по Ашхабаду (UTC+5). Точное время не выбирается.",
    "Delivery uses Ashgabat time (UTC+5). An exact time cannot be selected.",
    "Teslimat Aşkabat saatine (UTC+5) göredir. Kesin saat seçilemez."
  ],
  [
    "Поздравительная открытка",
    "Greeting card",
    "Tebrik kartı"
  ],
  [
    "Копировать текст",
    "Copy text",
    "Metni kopyala"
  ],
  [
    "Текст не указан",
    "No text provided",
    "Metin belirtilmedi"
  ],
  [
    "Пожелания к заказу",
    "Order requests",
    "Sipariş notları"
  ],
  [
    "Пожелания не указаны",
    "No requests provided",
    "Not belirtilmedi"
  ],
  [
    "Состав заказа",
    "Order contents",
    "Sipariş içeriği"
  ],
  [
    "Названия и описания сохранены на языке заказа.",
    "Names and descriptions are saved in the order’s language.",
    "Adlar ve açıklamalar sipariş dilinde kaydedilmiştir."
  ],
  [
    "Ручная корректировка суммы",
    "Manual total adjustment",
    "Tutarın elle düzeltilmesi"
  ],
  [
    "Итого",
    "Total",
    "Toplam"
  ],
  [
    "Оплачено с учётом возвратов",
    "Paid, after refunds",
    "İadeler sonrası ödenen"
  ],
  [
    "Осталось доплатить",
    "Amount due",
    "Kalan ödeme"
  ],
  [
    "Фотографии сборки",
    "Assembly photos",
    "Hazırlık fotoğrafları"
  ],
  [
    "JPEG, PNG или WebP до 10 МиБ; до 6000 px по стороне и 12 Мп. Не более 100 снимков в заказе.",
    "JPEG, PNG or WebP up to 10 MiB, 6000 px per side and 12 MP. Up to 100 photos per order.",
    "JPEG, PNG veya WebP; en fazla 10 MiB, kenar başına 6000 px ve 12 MP. Sipariş başına en fazla 100 fotoğraf."
  ],
  [
    "Добавить фото сборки",
    "Add assembly photo",
    "Hazırlık fotoğrafı ekle"
  ],
  [
    "Файл фотографии сборки",
    "Assembly photo file",
    "Hazırlık fotoğrafı dosyası"
  ],
  [
    "Выберите от 1 до 12 снимков для отправки покупателю.",
    "Select 1 to 12 photos to send to the customer.",
    "Müşteriye göndermek için 1 ile 12 fotoğraf seçin."
  ],
  [
    "Выбрано фотографий",
    "Photos selected",
    "Seçilen fotoğraf"
  ],
  [
    "Фотографии сборки пока не загружены.",
    "No assembly photos uploaded yet.",
    "Henüz hazırlık fotoğrafı yüklenmedi."
  ],
  [
    "Открыть фотографию сборки",
    "Open assembly photo",
    "Hazırlık fotoğrafını aç"
  ],
  [
    "Показана покупателю",
    "Shown to the customer",
    "Müşteriye gösteriliyor"
  ],
  [
    "Для подтверждения",
    "For approval",
    "Onay için"
  ],
  [
    "Убрать фотографию",
    "Remove photo",
    "Fotoğrafı kaldır"
  ],
  [
    "Фотография сборки",
    "Assembly photo",
    "Hazırlık fotoğrafı"
  ],
  [
    "История подтверждений",
    "Approval history",
    "Onay geçmişi"
  ],
  [
    "История заказа",
    "Order history",
    "Sipariş geçmişi"
  ],
  [
    "Последние 100 записей. Время указано в UTC.",
    "Latest 100 entries. Times are shown in UTC.",
    "Son 100 kayıt. Saatler UTC olarak gösterilir."
  ],
  [
    "Отправлено",
    "Sent",
    "Gönderildi"
  ],
  [
    "Завершено",
    "Resolved",
    "Sonuçlandı"
  ],
  [
    "Подтверждение больше не действует",
    "Approval is no longer valid",
    "Onay artık geçerli değil"
  ],
  [
    "Ожидает ответа",
    "Awaiting response",
    "Yanıt bekleniyor"
  ],
  [
    "Отменено",
    "Cancelled",
    "İptal edildi"
  ],
  [
    "Ручное изменение",
    "Manual change",
    "Elle değişiklik"
  ],
  [
    "Сотрудник",
    "Staff",
    "Çalışan"
  ],
  [
    "Покупатель",
    "Customer",
    "Müşteri"
  ],
  [
    "Гость",
    "Guest",
    "Misafir"
  ],
  [
    "Система",
    "System",
    "Sistem"
  ],
  [
    "Изменение заказа",
    "Order change",
    "Sipariş değişikliği"
  ],
  [
    "Изменения заказа сохранены.",
    "Order changes saved.",
    "Sipariş değişiklikleri kaydedildi."
  ],
  [
    "Текст открытки скопирован.",
    "Greeting card text copied.",
    "Tebrik kartı metni kopyalandı."
  ],
  [
    "Не удалось скопировать. Выделите текст открытки вручную.",
    "Could not copy. Select the greeting card text manually.",
    "Kopyalanamadı. Tebrik kartı metnini elle seçin."
  ],
  [
    "Заказ изменился. Обновите данные перед следующим действием.",
    "The order has changed. Refresh it before the next action.",
    "Sipariş değişti. Sonraki işlemden önce yenileyin."
  ],
  [
    "Загрузить актуальный заказ",
    "Load current order",
    "Güncel siparişi yükle"
  ],
  [
    "Ответ сервера не получен. Повторите то же действие, чтобы проверить результат без дублирования.",
    "No server response was received. Retry the same action to retrieve its result without duplication.",
    "Sunucu yanıtı alınamadı. İşlemi tekrarlamadan sonucunu almak için aynı eylemi yeniden deneyin."
  ],
  [
    "Покупатель получит выбранные фотографии. На ответ отводится 30 минут; затем сборка подтверждается автоматически. Уведомление отправляется по настройкам магазина.",
    "The customer will receive the selected photos and have 30 minutes to respond, after which assembly is approved automatically. Notifications follow store settings.",
    "Müşteriye seçilen fotoğraflar gönderilir ve yanıt için 30 dakika verilir; ardından hazırlık otomatik onaylanır. Bildirimler mağaza ayarlarına göre gönderilir."
  ],
  [
    "Текущее подтверждение перестанет действовать. После сборки отправьте фотографии заново; начнётся новый срок 30 минут.",
    "The current approval will become invalid. Send photos again after reassembly to start a new 30-minute period.",
    "Mevcut onay geçersiz olur. Yeniden hazırladıktan sonra fotoğrafları göndererek yeni bir 30 dakikalık süre başlatın."
  ],
  [
    "Фотография будет убрана из текущей сборки. Снимки, использованные для подтверждения, сохраняются в истории.",
    "The photo will be removed from the current assembly. Photos used for approval remain in history.",
    "Fotoğraf mevcut hazırlıktan kaldırılır. Onay için kullanılan fotoğraflar geçmişte saklanır."
  ],
  [
    "Ручная смена позволяет пропустить обычные этапы выполнения. Причина и сотрудник сохраняются в истории заказа.",
    "A manual change can skip normal fulfillment stages. The reason and staff member are recorded in order history.",
    "Elle değişiklik normal hazırlık aşamalarını atlayabilir. Gerekçe ve çalışan sipariş geçmişine kaydedilir."
  ],
  [
    "Новый статус",
    "New status",
    "Yeni durum"
  ],
  [
    "Причина изменения",
    "Reason for change",
    "Değişiklik gerekçesi"
  ],
  [
    "Комментарий к изменению",
    "Change comment",
    "Değişiklik notu"
  ],
  [
    "До 1000 символов.",
    "Up to 1000 characters.",
    "En fazla 1000 karakter."
  ],
  [
    "Необязательно. До 1000 символов.",
    "Optional. Up to 1000 characters.",
    "İsteğe bağlı. En fazla 1000 karakter."
  ],
  [
    "Загрузка закроет форму и заменит выбранные фотографии. Причину можно скопировать перед загрузкой.",
    "Loading closes this form and replaces selected photos. You can copy the reason first.",
    "Yükleme formu kapatır ve seçilen fotoğrafları değiştirir. Önce gerekçeyi kopyalayabilirsiniz."
  ],
  [
    "Применить действие",
    "Apply action",
    "İşlemi uygula"
  ],
  [
    "Срок истёк. Проверяем статус на сервере.",
    "The deadline has passed. Checking the server status.",
    "Süre doldu. Sunucudaki durum kontrol ediliyor."
  ],
  [
    "В обработке",
    "Processing",
    "İşleniyor"
  ],
  [
    "Ожидает подтверждения клиента",
    "Awaiting customer approval",
    "Müşteri onayı bekleniyor"
  ],
  [
    "Подтверждён клиентом",
    "Approved by customer",
    "Müşteri onayladı"
  ],
  [
    "Автоподтверждён",
    "Automatically approved",
    "Otomatik onaylandı"
  ],
  [
    "Передан курьеру",
    "With courier",
    "Kuryeye verildi"
  ],
  [
    "Доставлен",
    "Delivered",
    "Teslim edildi"
  ],
  [
    "Проблема",
    "Problem",
    "Sorun"
  ],
  [
    "Расчёты завершены",
    "Settled",
    "Ödemeler tamamlandı"
  ],
  [
    "Требуется доплата",
    "Payment due",
    "Ek ödeme gerekiyor"
  ],
  [
    "Требуется возврат",
    "Refund required",
    "İade gerekiyor"
  ],
  [
    "Возврат обрабатывается",
    "Refund pending",
    "İade işleniyor"
  ],
  [
    "Требуется финансовая сверка",
    "Financial review required",
    "Mali mutabakat gerekiyor"
  ],
  [
    "Отправить на подтверждение",
    "Send for approval",
    "Onaya gönder"
  ],
  [
    "Вернуть на сборку",
    "Return to assembly",
    "Hazırlamaya geri al"
  ],
  [
    "Передать курьеру",
    "Hand to courier",
    "Kuryeye ver"
  ],
  [
    "Отметить доставленным",
    "Mark delivered",
    "Teslim edildi olarak işaretle"
  ],
  [
    "Сообщить о проблеме",
    "Report a problem",
    "Sorun bildir"
  ],
  [
    "Ручная смена статуса",
    "Change status manually",
    "Durumu elle değiştir"
  ],
  [
    "Выберите от 1 до 12 фотографий текущей сборки.",
    "Select 1 to 12 photos of the current assembly.",
    "Mevcut hazırlıktan 1 ile 12 fotoğraf seçin."
  ],
  [
    "Выберите другой статус. Подтверждение отправляется отдельным действием с фотографиями.",
    "Select a different status. Approval is sent with photos using its own action.",
    "Başka bir durum seçin. Onay, fotoğraflarla ayrı bir işlem olarak gönderilir."
  ],
  [
    "Укажите причину до 1000 символов.",
    "Enter a reason of up to 1000 characters.",
    "En fazla 1000 karakterlik bir gerekçe girin."
  ],
  [
    "Действие больше недоступно. Обновите заказ.",
    "This action is no longer available. Refresh the order.",
    "Bu işlem artık kullanılamıyor. Siparişi yenileyin."
  ],
  [
    "Проверьте период оплаты: конечная дата должна быть не раньше начальной.",
    "Check the payment period: the end date must not precede the start date.",
    "Ödeme dönemini kontrol edin: bitiş tarihi başlangıçtan önce olamaz."
  ],
  [
    "Заказ изменился или действие больше недоступно. Загрузите актуальные данные.",
    "The order has changed or this action is no longer available. Load the current data.",
    "Sipariş değişti veya işlem artık kullanılamıyor. Güncel verileri yükleyin."
  ],
  [
    "Эта фотография уже использовалась для подтверждения и должна остаться в истории.",
    "This photo was used for approval and must remain in history.",
    "Bu fotoğraf onay için kullanılmıştır ve geçmişte kalmalıdır."
  ],
  [
    "Проверьте фотографии, причину и выбранный статус.",
    "Check the photos, reason and selected status.",
    "Fotoğrafları, gerekçeyi ve seçilen durumu kontrol edin."
  ],
  [
    "Оплата получена",
    "Payment received",
    "Ödeme alındı"
  ],
  [
    "Сборка отправлена на подтверждение",
    "Assembly sent for approval",
    "Hazırlık onaya gönderildi"
  ],
  [
    "Клиент подтвердил сборку",
    "Customer approved assembly",
    "Müşteri hazırlığı onayladı"
  ],
  [
    "Клиент сообщил о проблеме",
    "Customer reported a problem",
    "Müşteri sorun bildirdi"
  ],
  [
    "Сборка подтверждена автоматически",
    "Assembly approved automatically",
    "Hazırlık otomatik onaylandı"
  ],
  [
    "Статус изменён",
    "Status changed",
    "Durum değiştirildi"
  ],
  [
    "Заказ возвращён на сборку",
    "Order returned to assembly",
    "Sipariş hazırlamaya geri alındı"
  ]
];
export default entries;
